let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6wiUh")).then(() => parcelRequire('iup85'));